import { useDispatch } from 'react-redux';
import { hideJobsInvitePopup } from '~/actions';
import { useAppSelector } from '~/hooks/useAppSelector';
import { InviteProfessionalPopup } from '../commonComponents/InviteProfessional/Popup';
import Portal from '../commonComponents/Portal';

export const JobsInviteSelectionPopup = () => {
  const dispatch = useDispatch();
  const { showSelection, jobIds, profession, officeId } = useAppSelector(
    (state) => state.multiday.jobsInvitePopup,
  );

  if (!showSelection || !jobIds?.length) {
    return null;
  }

  return (
    <Portal>
      <div onClick={(e) => e.stopPropagation()}>
        <InviteProfessionalPopup
          isOpen
          isRefetchJob={false}
          jobIds={jobIds}
          profession={profession}
          officeId={officeId}
          onClose={() => dispatch(hideJobsInvitePopup())}
          trackingSource="Invite Recommendation"
        />
      </div>
    </Portal>
  );
};
